import React from "react";
import { NavLink } from 'react-router-dom'
import himg from '../../images/slider/1.png'
import { Link } from 'react-scroll'

const Hero =() => {
    return (
        <section className="tp-hero-section-1">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-7 col-lg-7">
                        <div className="tp-hero-section-text">
                            <div className="tp-hero-title">
                                <h2>App & Software Developer</h2>
                            </div>
                            <div className="tp-hero-sub">
                                <p>Yasser Mejri</p>
                            </div>
                            <div className="btns">
                                <Link activeClass="active" to="contact" spy={true} smooth={true} duration={500} offset={-95} className="theme-btn">Contact Me</Link>
                                &nbsp;
                                <a activeClass="active" href="/YasserMejri.pdf" className="theme-btn">Resume</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="right-vec">
                <div className="right-img">
                    <img src={himg} alt="" style={{ aspectRatio: "687 / 959", objectFit: "cover" }}/>
                </div>
            </div>
            <div className="social-link">
                <ul>
                    <li><NavLink to="https://www.linkedin.com/in/yasser-mj/">LinkedIn</NavLink></li>
                    <li><NavLink to="https://github.com/yasserMejri">Github</NavLink></li>
                    <li><NavLink to="mailto:yassermejri0988@gmail.com">Email</NavLink></li>
                </ul>
            </div>
            <div className="visible-text">
                <h1>Developer</h1>
            </div>
        </section>
    )
}

export default Hero;